import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";
import LinearLoaderWithTime from "../../../components/Loaders/LinearLoaderWithTime";
import { AdleLogoLoader } from "../../../assets/svg/AdleLogoLoader";
import { useTranslationApp } from "../../../lib/i18next";
import {
  GLOBAL_REPORT_HEAVY_LOAD_ANALYZING,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS,
  GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS,
  GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS,
} from "../../../i18n/keysTranslations";
import { IS_ADLE_DOMAIN } from "../../../utils/constants";

/** Target duration for portfolio reports with many campaigns (stats + AI). */
export const GLOBAL_REPORT_HEAVY_LOAD_TIME_MS = 90_000;

/**
 * After the first candidates fetch, keep the timed loader from this count up.
 * Below this threshold the UI switches to section skeletons.
 */
export const GLOBAL_REPORT_HEAVY_LOAD_MIN_CAMPAIGNS = 5;

const GlobalReportHeavyLoadPanel = ({ resetKey }) => {
  const { t } = useTranslationApp();
  const theme = useTheme();

  const labels = useMemo(
    () => [
      t(GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS),
      t(GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS),
      t(GLOBAL_REPORT_HEAVY_LOAD_ANALYZING),
      t(GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS),
    ],
    [t]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        gap: 2,
        mt: 3
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        {IS_ADLE_DOMAIN && <AdleLogoLoader />}
        <LinearLoaderWithTime
          key={resetKey || "global-report-heavy-load"}
          labelSide="bottom"
          time={GLOBAL_REPORT_HEAVY_LOAD_TIME_MS}
          labels={labels}
          sx={{ width: "100%" }}
          sxLabel={{
            color: theme.palette.text.primary,
            mt: 1.5,
            fontWeight: 500,
          }}
        />
      </Box>
    </Box>
  );
};

export default GlobalReportHeavyLoadPanel;
